// Polish-aware slug generator. Used to derive a blog post's URL (Firestore doc id)
// from its title or a custom slug entered in the editor.

const PL_MAP = {
  ą: 'a', ć: 'c', ę: 'e', ł: 'l', ń: 'n', ó: 'o', ś: 's', ź: 'z', ż: 'z',
};

export function slugify(text) {
  if (typeof text !== 'string') {
    return '';
  }

  return text
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, (char) => PL_MAP[char] || char)
    // strip any remaining diacritics (é, ü, etc.)
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    // anything that is not a-z, 0-9 becomes a separator
    .replace(/[^a-z0-9]+/g, '-')
    // collapse and trim separators
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
